import React, {Component} from 'react';
import {Table, Thead, Tbody, Tr, Td, Th, filterBy} from 'reactable';
import {Button} from 'src/components/Common/reactstrap/lib';
import styles from '../Orders.scss';// todo:extract to general
import TableSupplier from '../../CartPage/elements/tableElements/TableSupplier';
import OrdersModalStatus from './OrdersModalStatus';
import {map, concat, filter, reduce} from 'lodash';

import InlineSVG from 'react-svg-inline';

import InfiniteScroll from 'react-infinite-scroller';
import dialog from 'src/imgs/dialog.svg';
import * as ORDER_STATE from '../../../constants/orderStateConstatns';
import {compareValue} from '../../../logic/utils';
import moment from 'moment';

export default class OrdersTable extends Component {


  render() {

    let loader = <div className="loader">Загрузка ...</div>,
      {OrdersData, filterBy} = this.props,
      orders = filter(OrdersData.orders, (order) => {
        //filters = ['№ заказа','Наименование','Комментарий','Поставщик','Дата заказа']
        return compareValue(order.orderId, filterBy)
          || compareValue(order.brandName + ' ' + order.detailArticle, filterBy)
          || compareValue(order.comment, filterBy)
          || compareValue(order.logo, filterBy)
          || compareValue(order.addDate, filterBy);
      });

    const forClassBtn = (value) => {
      return (value.state == ORDER_STATE.CANCELED_BY_SUPPLIER || value.state == ORDER_STATE.CANCELED_BY_ADMIN) && value.isArchived == false
        ? styles.with_buttons : '';
    };
    const portion = (data) => {
        return map(data.portions, (value) => {
          let statusModal = false, statusStyle = '', status = '',
            wthBtn = (value.state == ORDER_STATE.CANCELED_BY_SUPPLIER || value.state == ORDER_STATE.CANCELED_BY_ADMIN) && value.isArchived == false;
          switch (value.state) {
            case ORDER_STATE.ORDERED_BY_CUSTOMER:
            case ORDER_STATE.REQUESTED_FROM_SUPPLIER:
            case ORDER_STATE.APPROVED_BY_SUPPLIER:
            case ORDER_STATE.EXPECTED_IN_STOCK:
            case ORDER_STATE.IN_STOCK:
              statusModal = true; //'В работе'
              break;
            case ORDER_STATE.SENDED_TO_CUSTOMER:
              statusModal = true;
              break;
            case ORDER_STATE.RECEIVED_BY_CUSTOMER:
              status = 'Выдан';
              statusStyle = 'text-muted';
              break;
            case ORDER_STATE.CANCELED_BY_SUPPLIER:
            case ORDER_STATE.CANCELED_BY_ADMIN:
              status = 'Отменён';
              statusStyle = 'text-danger';
              break;
            default:
              status = '';
              statusStyle = 'text-muted';
          }
          return (
            <div className={forClassBtn(value)}>
              {statusModal ? (<OrdersModalStatus className="modal-wide" portionState={value.state} {...data}/>) : (
                <span className={statusStyle}>{status}</span>)}
              {wthBtn &&
              <div className="m-t-0_5">
                <Button className="small" href={`search?article=${data.detailArticle}`}>Перезаказать</Button>
                <Button className="small" onClick={() => this.props.setArchive(value.portionId)}> В
                  архив</Button></div>}
            </div>
          );
        });
      },
      ready = (portion) => {//?
        return map(portion, (value) => {
          return (value.state != ORDER_STATE.CANCELED_BY_SUPPLIER || value.state != ORDER_STATE.CANCELED_BY_ADMIN) ? moment(value.readyDate, 'YYYY-MM-DDThh:mm:ssZ').format('ll') : ''
        });
      },
      price = (data) => {
        return map(data.portions, (value) => {
          return <div className={forClassBtn(value)}>{data.price.toLocaleString()}</div>;
        });
      },
      quantity = (portion) => {
        return map(portion, (value) => {
          return <div className={forClassBtn(value)}>{value.quantity.toLocaleString()}</div>;
        });
      },
      total = (data) => {
        return map(data.portions, (value) => {
          return <div className={forClassBtn(value)}>{(value.quantity * data.price).toLocaleString()}</div>;
        });
      },
      tableRows = map(orders, (value) => {
        if (value.orderId > 0)
          return (
            <tr key={value.orderId}>
              <td style={{width: '6%'}}>
                {value.orderId}
              </td>
              <td style={{width: '13%'}} value={`${value.brandName} ${value.detailArticle}`}>
                <div className={styles.name}>
                  <p>{value.brandName} <a className="link"
                                          href={`search?article=${value.detailArticle}`}>{value.detailArticle}</a></p>
                  {value.detailName} <a href="#"></a>
                </div>
              </td>
              <td style={{width: '15%'}} value={value.comment}>
                <span className="text-muted font-italic">{value.comment}</span>
              </td>
              <td style={{width: '10%'}} value={value.logo}>
                <TableSupplier logo={value.logo} rating={value.rating}/>
              </td>
              <td style={{width: '5%'}} value={moment(value.addDate).format('DD MMM YY HH:mm')}>
                {moment(value.addDate).format('DD MMM YY HH:mm')}
              </td>
              <td style={{width: '15%'}}>
                <div>{portion(value)}</div>
              </td>
              <td>
                <div>{price(value)}</div>
              </td>
              <td>
                <div>{quantity(value.portions)}</div>
              </td>
              <td>
                <div>{total(value)}</div>
              </td>
              <td className="last-row" style={{width: '2%'}}>
                <a className={styles.icon_dialog} href="#"><InlineSVG
                  svg={dialog}/> {value.stateId == ORDER_STATE.IN_STOCK && <span className={styles.number}>2</span> }
                </a>
              </td>
            </tr>
          );
        else return <tr></tr>;
      }),
      thead = (
        <thead>
        <tr>
          <th>
            № заказа
          </th>
          <th>
            Наименование
          </th>
          <th>
            Комментарий
          </th>
          <th>
            Поставщик
          </th>
          <th>
            Дата заказа
          </th>
          <th>
            Статус
          </th>
          <th>
            Цена за шт, &#8381;
          </th>
          <th>
            Кол-во, шт.
          </th>
          <th>
            Сумма, &#8381;
          </th>
          <th>
          </th>
        </tr>
        </thead>);

    return (
      <table className={styles.table}>
        {thead}

        {tableRows.length > 0 && !filterBy ? <InfiniteScroll
          pageStart={0}
          initialLoad={true}
          element="tbody"
          loadMore={this.props.loadMore}
          hasMore={OrdersData.isNext}
          loader={loader}>
          {tableRows}
        </InfiniteScroll> : <tbody>{tableRows}</tbody>}

      </table>
    );


  }
}

/**
 *  hideFilterInput
 filterBy={this.props.filterBy}
 filterable={filters}
 noDataText="Заказы не найдены"
 * [
 {
     column: 'State',
     filterFunction: function(contents, filter) {
         // case-sensitive filtering
         return (contents.indexOf(filter) > -1);
     }
 }
 */



/** WEBPACK FOOTER **
 ** ./src/components/User/elements/OrdersTable.jsx
 **/